import React, { useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { MainDynamicAGTable } from '../components/MainDynamicAgTable'
import { downloadS3File } from '../../../../utils/ExportExcel'
import { IndividualTablePage } from '../components/IndividualTablePage'
import { ReadExcelFile } from '../components/ReadExcelFileData'
import {
  DynamicTableFilterInput,
  DynamicTablePublicAccessInput,
  GetDynamicFilterInput,
} from '../../../../generated/graphql'
import Toast, { ToastType } from '../../../../utils/toast'
import { fetchData } from '../components/MainDynamicAGComponent'
import { useNavigate } from 'react-router-dom'
import { RefetchUserContext } from '../../../../utils/RefetchUserContext'
import { useCanUserAccess } from '../../store/userRoleGrants'

export type DynamicTableDataInputType = {
  data: String[][]
  file: File
  id: number
  indexData: any
  primaryColumns?: number[]
  secondaryColumns?: number[]
}

export type DynamicTableDataInput = {
  name: string
  description: string
  tableData: any
  chartData: any
  file: File | undefined
  isExisting: boolean
  isPublished: boolean
  id?: number
}

export type DynamicTableDataType = {
  id: number
  userId: number
  name: string
  description: string
  tableData: any
  chartData: any
  fileUrl: string
  googleSheetLink?: string
  fileName: string
  isPublished?: boolean
}

type DynamicTableProps = {
  data?: DynamicTableDataType[]
  isSuperAdmin?: boolean
  handleSave: Function
  handleRemove: Function
  filterData?: any
  saveFilter: Function
  removeFilter: Function
  onSelectTable: Function
  publishTable?: Function
  publishedTable?: any
  loaders?: any
}

function DynamicTablePageWrapper(props: DynamicTableProps) {
  const fileInputRef = useRef() as React.MutableRefObject<HTMLInputElement>
  const [excelFile, setExcelFile] = useState<File>()
  const [excelData, setExcelData] = useState<String[][]>([])
  const [dynamicTableData, setDynamicTableData] = useState<DynamicTableDataInputType[]>([])
  const [fileUploadKey, setFileUploadKey] = useState<number>(0)
  const [showTable, setShowTable] = useState<boolean>(props.publishedTable ? false : true)
  const [showDetailedTable, setShowDetailedTable] = useState<boolean>(false)
  const [showExistingTable, setShowExistingTable] = useState<boolean>(false)
  const [existingData, setExistingData] = useState<DynamicTableDataType>()

  const navigate = useNavigate()
  const handleButtonClick = () => {
    // Reset the file input value to allow selecting the same file again
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
    fileInputRef.current.click()
  }

  const handleFileChange = (event: any) => {
    const file = event.target.files[0]
    if (file) {
      setExcelFile(file)
      setFileUploadKey((prev) => prev + 1)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      if (excelFile) {
        try {
          const dynamicData = await ReadExcelFile(excelFile)
          if (dynamicData[0]?.indexData?.length === undefined) {
            Toast('Invalid Excel File, Please verify and upload a valid file.', ToastType.error)
            return
          }
          if (dynamicData[0]?.indexData?.length === 0) {
            Toast('The index data does not match the required template.', ToastType.error)
            return
          } else {
            setDynamicTableData(dynamicData)
          }
        } catch (error) {
          console.error('Error reading the Excel file:', error)
        }
      }
    }

    fetchData()
  }, [excelFile, fileUploadKey])

  useEffect(() => {
    if (dynamicTableData.length > 0) {
      setShowDetailedTable(true)
      setShowTable(false)
    }
  }, [dynamicTableData])

  function handleSaveTable(values: DynamicTableDataType) {
    props.handleSave(values)
  }

  useEffect(() => {
    props.onSelectTable(existingData)
  }, [existingData])
  const canDynamicTables = useCanUserAccess('read', 'dynamicTable')
  const isSuperAdmin = sessionStorage.getItem('isSuperAdmin') === 'true' ? true : false

  // useEffect(() => {
  //   const fetchPublishedData = async () => {
  //     if (props.publishedTable?.fileUrl) {
  //       const data = await fetchData(props.publishedTable.fileUrl)
  //       if (!data) {
  //         await RefetchUserContext()
  //         Toast('This published table is no longer available.', ToastType.error)
  //         if (isSuperAdmin || canDynamicTables) {
  //           navigate('/privateData')
  //         } else {
  //           navigate('/dashboard')
  //         }
  //         return
  //       }
  //       console.log('INSIDE READING DATA:', data)
  //       if (data)
  //         setExistingData({
  //           ...props.publishedTable,
  //           tableData: { data: data[0].data, indexData: data[0] },
  //         })

  //       setShowExistingTable(true)
  //     }
  //     if (!props.publishedTable) {
  //       setShowExistingTable(false)
  //       setShowTable(true)
  //     }
  //   }

  //   fetchPublishedData()
  // }, [props.publishedTable?.fileUrl])

  return (
    <>
      {showDetailedTable && (
        <IndividualTablePage
          data={dynamicTableData[0]}
          isPublishedTable={props.publishedTable ? true : false}
          isSuperAdmin={props.isSuperAdmin}
          isExisting={false}
          handleBack={() => {
            setShowTable(true)
            setShowDetailedTable(false)
            navigate(`/privateData`)
          }}
          handleSubmit={(values: DynamicTableDataType) => handleSaveTable(values)}
          filterData={props.filterData}
          saveFilter={(values: DynamicTableFilterInput) => props.saveFilter(values)}
          removeFilter={(values: GetDynamicFilterInput) => props.removeFilter(values)}
          publishTable={(values: DynamicTablePublicAccessInput) => {
            if (props.publishTable) props.publishTable(values)
          }}
          loaders={props.loaders}
          onSyncData={(values: DynamicTableDataType) => {
            setExistingData(values)
          }}
        />
      )}
      {showExistingTable && (
        <IndividualTablePage
          existingData={existingData}
          isPublishedTable={props.publishedTable ? true : false}
          isSuperAdmin={props.isSuperAdmin}
          isExisting={true}
          handleBack={() => {
            setShowTable(true)
            setShowExistingTable(false)
            navigate(`/privateData`)
          }}
          handleSubmit={(values: DynamicTableDataType) => handleSaveTable(values)}
          filterData={props.filterData}
          saveFilter={(values: DynamicTableFilterInput) => props.saveFilter(values)}
          removeFilter={(values: GetDynamicFilterInput) => props.removeFilter(values)}
          publishTable={(values: DynamicTablePublicAccessInput) => {
            if (props.publishTable) props.publishTable(values)
          }}
          loaders={props.loaders}
          onSyncData={(values: DynamicTableDataType) => {
            setExistingData(values)
          }}
        />
      )}
      {showTable && !props.publishedTable && (
        <>
          {/* Captable AG Table */}
          <div className='row mb-9 px-3 mt-3'>
            <div className='col-12'>
              <div className='row gap-8'>
                <div
                  className='card p-6 col-6 col-md-2 cursor-pointer bg-gray-300 h-auto border border-gray-100 border-2 border-hover-primary-light'
                  style={{
                    transition: '500ms',
                  }}
                  onClick={() => handleButtonClick()}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen035.svg'
                    className='svg-icon-3x text-primary pb-2'
                  />
                  <h3 className='fw-bold mb-0'>Create New Table</h3>
                  <p className='fs-8'>Start by uploading Excel file</p>
                </div>
                <input
                  type='file'
                  accept='.xlsx, .xls'
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                />
                <div
                  className='card p-6 col-6 col-md-2 cursor-pointer bg-gray-300 h-auto border border-gray-100 border-2 border-hover-success'
                  style={{
                    transition: '500ms',
                  }}
                  onClick={() =>
                    downloadS3File(
                      'https://equion-dev.s3.us-west-2.amazonaws.com/invp-templates/SampleTemplate.xlsx'
                    )
                  }
                >
                  <i
                    className='bi bi-download fs-2qx text-success-active pb-3 pt-1'
                    style={{ fontWeight: 'bold' }}
                  ></i>
                  <h3 className='fw-bold mb-0'>Download Template</h3>
                  <p className='fs-8'>Refer to sample template</p>
                </div>
              </div>
            </div>
          </div>
          {/* main Ag table */}
          <div className='row mb-9'>
            <div className='col-12'>
              <MainDynamicAGTable
                data={props.data as DynamicTableDataType[]}
                isSuperAdmin={props.isSuperAdmin}
                handleBack={() => {
                  setShowTable(true)
                  setShowDetailedTable(false)
                }}
                handleSubmit={(values: DynamicTableDataType) => handleSaveTable(values)}
                handleRemove={(event: React.MouseEvent, id: number) =>
                  props.handleRemove(event, id)
                }
                navigate={(values: DynamicTableDataType) => {
                  setExistingData(values)
                  setShowExistingTable(true)
                  navigate(`/privateData/${values.id}`)
                  setShowTable(false)
                }}
                publishTable={(values: DynamicTablePublicAccessInput) => {
                  if (props.publishTable) props.publishTable(values)
                }}
                loaders={props.loaders}
              />
            </div>
          </div>
        </>
      )}
    </>
  )

  return <></>
}

export default DynamicTablePageWrapper
